import { KeyintInt } from '@interfaces/'
export class KeyModel implements KeyintInt {
  key: string;
  description: string;
  code: number;
  disabled: boolean;

  constructor(key: string, description: string, code: number) {
    this.key = key;
    this.description = description;
    this.code = code;
  }
}
